import React from 'react';

import { Box, Button, CircularProgress } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { ExtendedPanel } from '@components/operatorSession/usePanelSelected';
import { useOperatorSession } from '@contexts/OperatorSeesionProvider';
import getEnumTranslation from '@utils/getEnumTranslation';

type CallButtonsProps = {
    onCancel: (openPanel: ExtendedPanel) => void;
};

const CallButtons = ({ onCancel }: CallButtonsProps) => {
    const { endSession, isSubmitting } = useOperatorSession();
    return (
        <>
            {isSubmitting ? (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <CircularProgress
                        data-testid="submitting-progress"
                        size="2rem"
                        sx={{
                            color: 'primary.contrastText',
                        }}
                    />
                </Box>
            ) : (
                <Box
                    sx={{
                        mt: 1.25,
                    }}>
                    <Button
                        onClick={() => onCancel('CLOSED')}
                        sx={{
                            color: 'primary.contrastText',
                        }}>
                        {getEnumTranslation('cancel')}
                    </Button>
                    <Button
                        onClick={() => endSession()}
                        disabled={isSubmitting}
                        variant="outlined"
                        disableElevation
                        size="large"
                        sx={{
                            ml: 1,
                            backgroundColor: 'background.paper',
                            '&:hover': {
                                backgroundColor: 'primary.dark',
                                color: 'primary.contrastText',
                            },
                        }}>
                        <FormattedMessage
                            id="CallButtons.submit"
                            defaultMessage="Submit Report"
                        />
                    </Button>
                </Box>
            )}
        </>
    );
};

export default CallButtons;
